// extracted by mini-css-extract-plugin
export default {"downloadButton":"Attachment_downloadButton__zg3v4"};